<template>
  <div>
    <button class="btn btn-simple btn-primary" @click="Add()">Добавить</button>
    <div v-if="bIsLoading">Загружаем данные...</div>
    <card v-else>
            <el-table :data="ApiSitesTable" style="width: 100%;">
                <el-table-column
                    label="ID"
                    property="siteId"
                    width="80"
                >
                </el-table-column>
                <el-table-column 
                    min-width="180"
                    label="Площадка"
                    property="name"
                >
                </el-table-column>
                <el-table-column 
                    min-width="160"
                    label="Тип выгрузки"
                    property="local"
                >
                    <template v-slot="scope">	
                        {{ decodeExport(scope.row.local) }}
                        {{ scope.row.act=='0' ? '(Отключено)':'' }}
                    </template>
                </el-table-column>
                <el-table-column 
                    label="Ссылка"
                    property="local">
                    <template v-slot="scope">	
                        <a v-if="scope.row.local==3||scope.row.local==2" :href="'/export/'+(scope.row.feedName||scope.row.destination)+'.xml'">{{ (scope.row.feedName||scope.row.destination) }}.xml</a>
                    </template>

                </el-table-column>
                <el-table-column
                        width="280"
                        label="Действие"
                        align="right"                    	
                >
                    <template v-slot="scope">
                        <!-- 
                        <el-tooltip content="Управление доступами к пакетам" placement="top">
                            <el-button class="no-border my-0">
                                <button class="btn btn-icon btn-simple btn-info" @click="GoAccessEdit(scope.row)">
                                    <i class="tim-icons icon-settings-gear-63"></i>
                                </button>											
                            </el-button>
                        </el-tooltip>
                        -->
                        <template v-if="canEdit">
                            
                            <el-tooltip content="Редактировать настройки площадки" placement="top">
                                <el-button class="no-border my-0 mr-3">
                                    <button class="ml-1 btn btn-icon btn-simple btn-primary" @click="GoEdit(scope.row)">
                                        <i class="tim-icons icon-pencil"></i>
                                    </button>
                                </el-button>
                            </el-tooltip>		

                            <el-tooltip content="Редактировать продвижения" placement="top">
                                <el-button class="no-border my-0 mr-3">
                                    <button class="ml-1 btn btn-icon btn-simple btn-primary" @click="GoTerms(scope.row)">
                                        <i class="tim-icons icon-user-run"></i>
                                    </button>
                                </el-button>
                            </el-tooltip>		
                            

                            <!-- <div class="d-flex justify-content-end"></div> -->
                        </template>	
                                
                    </template>
                </el-table-column>
            
            </el-table>
        </card>
        <button class="btn btn-simple btn-primary" @click="Add()">Добавить</button>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';

export default {
  name: 'SitesEditor',
  components: {
        [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,        
	},
  data() {
    return {
      ApiSitesTable: [],
      bIsLoading: true,
    };
  },
  computed:{
    canEdit(){
        return this.$GVO.my_profile.adm
    }
  },
  methods: {
    decodeExport(t){
        switch(t){
            case 2: return 'Локальная';
            case 1: return 'Зипал';
            case 0:
            case 3: return 'Локальная + Зипал';
        }
        return 'Тип: '+t;
    },    
    getApiSites(){
        this.bIsLoading=true;
        this.$GVO.ApiCall('marketing_sites.GET',{flt:{terms:false,}})
        .then((objApi) => {
            // this.ApiSitesTable = [];
            if(objApi.success === true){
                if(objApi.data.length > 0){
                    this.ApiSitesTable = objApi.data;
                    // if(objApi.total!=undefined) { this.masObjectsNew_total=objApi.total; }
                }else{
                    this.ApiSitesTable=[];
                }
            }
            this.bIsLoading = false;
        }).catch(errorObjApi => {console.error(errorObjApi); this.ApiSitesTable = [];});
    },	
    Add(){
        this.$router.push({path: '/data/sites/add'});
	},
    GoEdit(row){
        this.$router.push({path: '/data/sites/'+row.siteId});
    },
    GoTerms(row){
        this.$router.push({path: '/data/sites/'+row.siteId+'/terms'});
    },

  },
  mounted() {
    this.getApiSites();
  }
};
</script>

<style scoped>

</style>